(function () {
    "use strict";

    angular.module("app").controller("CisDossierController", CisDossierController);

    CisDossierController.$inject = ["controllerDecorator", "cisDossier"];
    function CisDossierController(controllerDecorator, cisDossier) {

        const context = { CisId: null };

        const vm = this;

        vm.PurposeStyle = function (purpose) {
            const styles = {
                Icon: "fa-times",
                Text: ""
            };

            if (!vm.dossier) {
                return styles;
            }

            if (vm.dossier.Purposes.includes(purpose)) {
                styles.Icon = "fa-check";
                styles.Text = { "font-weight": "bold" };
            }

            return styles;
        };

        activate();

        function activate() {
            controllerDecorator.Decorate(vm, []);

            const parsed = vm.ParsePrettyUrl();
            context.CisId = parsed.id;

            if (context.CisId !== null) {
                load();
            }
            else {
                vm.SetLoadingState(false);
                vm.ShowError("Cannot activate view");
            }
        }

        function load() {
            cisDossier.Get(
                context.CisId,
                r => {
                    vm.dossier = r.data;
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );

            cisDossier.GetRequests(
                context.CisId,
                r => vm.Requests = r.data,
                vm.ShowError,
            );
        }
    }
})();
